import { StatStrip } from '@/components/ds'
import { Skeleton } from '@/components/ui/skeleton'
import { AdminAuthActivity, AdminDashboardSummary } from '@/interfaces/AdminDashboard'

import { AuthActivityChart } from './AuthActivityChart'

type PeriodDays = 7 | 30 | 90

interface AdminDashboardProps {
  summary?: AdminDashboardSummary
  activity?: AdminAuthActivity
  days: PeriodDays
  onDaysChange: (days: PeriodDays) => void
}

const formatNumber = (value: number) => value.toLocaleString('cs-CZ')

const Big = ({ value }: { value: number | undefined }) =>
  value === undefined ? (
    <span className="text-2xl text-muted-foreground">-</span>
  ) : (
    <span className="text-2xl font-medium tracking-[-0.02em] tabular">{formatNumber(value)}</span>
  )

export const AdminDashboard = ({ summary, activity, days, onDaysChange }: AdminDashboardProps) => {
  const activePercentage =
    summary && summary.totalAccounts > 0
      ? Math.round((summary.activeAccountsLast6Months / summary.totalAccounts) * 100)
      : 0

  const logins = activity?.data.reduce((sum, day) => sum + day.logins, 0)
  const signups = activity?.data.reduce((sum, day) => sum + day.signups, 0)

  return (
    <div className="space-y-6">
      <StatStrip
        items={[
          { label: 'Registrované účty', value: <Big value={summary?.totalAccounts} />, hint: summary ? 'celkem' : 'nepodařilo se načíst' },
          {
            label: 'Aktivní účty',
            value: <Big value={summary?.activeAccountsLast6Months} />,
            hint: summary ? `${activePercentage} % za posledních 6 měsíců` : 'nepodařilo se načíst',
          },
          { label: 'Přihlášení', value: <Big value={logins} />, hint: `za ${days} dní` },
          { label: 'Registrace', value: <Big value={signups} />, hint: `za ${days} dní` },
        ]}
      />

      {activity ? (
        <AuthActivityChart data={activity} days={days} onDaysChange={onDaysChange} />
      ) : (
        <Skeleton className="h-[22rem] w-full rounded-lg" />
      )}
    </div>
  )
}
